import React, { useCallback, useEffect, useState } from "react";
import { PieChart } from "../Components/PieChart";
import { KeyedValue } from "Components";
import {
  PresaveSource,
  ReleasePresave,
} from "@max/common/dist/artists/presave";
import { setbioColors, setfanColors, Source } from "../types";

const LABELS: Record<PresaveSource, string> = {
  "setbio:takeover": "SET.Bio Take-Over",
  "setbio:section": "SET.Bio Section",
  setfan: "SET.Fan",
  setlive: "SET.Live",
  auto: "Auto Pre-Save",
};

interface Props {
  preSaves: ReleasePresave[];
  releaseId?: string;
  sources: PresaveSource[];
  source?: Source;
}

export const SourceChart: React.FC<Props> = ({
  releaseId,
  preSaves,
  sources,
  source,
}) => {
  const [data, setData] = useState<KeyedValue[]>([]);

  const getData = useCallback(() => {
    const preSavesBySource = Object.fromEntries(
      sources.map((source) => [source, 0]),
    );

    for (const preSave of preSaves) {
      for (const source of sources) {
        if (source === preSave.completedReleases[releaseId].source) {
          preSavesBySource[source] += 1;
        }
      }
    }

    return Object.entries(preSavesBySource).map(([source, count]) => ({
      id: source,
      label: LABELS[source],
      count: count,
    }));
  }, [preSaves, releaseId, sources]);

  useEffect(() => {
    const data = getData();
    setData(data);
  }, [getData]);

  return (
    <PieChart
      title="Pre-Save Source"
      data={data}
      colors={source === "setfan" ? setfanColors : setbioColors}
    />
  );
};
